module.exports = __webpack_public_path__ + "img/8.eef3dd17.jpeg";